import { render, staticRenderFns } from "./MyAccountEditPage.vue?vue&type=template&id=198ad453"
import script from "./MyAccountEditPage.vue?vue&type=script&lang=js"
export * from "./MyAccountEditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports